/**
 * Shared AJAX add-to-cart for homepage section forms.
 * Intercepts submits on .fps__card-form, .z38__card-form, .f24__card-form, .fh__card-form
 * and opens the cart drawer instead of redirecting to /cart.
 */
(function () {
  if (window.__sectionCartAjaxBound) return;
  window.__sectionCartAjaxBound = true;

  const SELECTOR = '.fps__card-form, .z38__card-form, .f24__card-form, .fh__card-form';

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest(SELECTOR);
    if (!form) return;

    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (button && button.disabled) return;

    const variantInput = form.querySelector('input[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId) return;

    const cart = document.querySelector('cart-drawer');
    const originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.dataset.loading = 'true';
      button.textContent = 'Wird hinzugefügt…';
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((s) => s.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    try {
      const response = await fetch(
        (window.routes && window.routes.cart_add_url) || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        }
      );
      const data = await response.json();

      if (data.status) {
        console.error('Cart add error:', data.description || data.message);
        if (button) {
          button.textContent = 'Fehler';
          setTimeout(() => {
            button.textContent = originalLabel;
            button.disabled = false;
            delete button.dataset.loading;
          }, 1500);
        }
        return;
      }

      if (cart) {
        cart.renderContents(data);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (err) {
      console.error('Cart add fetch error:', err);
    } finally {
      if (button) {
        button.disabled = false;
        delete button.dataset.loading;
        button.textContent = originalLabel;
      }
    }
  });
})();
